'use client'

import { initializeClientTelemetry } from '@/lib/telemetry-client'
import { useEffect } from 'react'

export default function TelemetryInitializer() {
  useEffect(() => {
    // Use client-safe telemetry initialization
    initializeClientTelemetry()
  }, [])

  return null
}
